import { styled, useTheme } from '@mui/material';
import React from 'react';
import { Typography } from '../Typography/Typography';
import { Breadcrumb } from '../../types';
import { useNavigate } from 'react-router';
import { useAtomValue } from 'jotai';
import { isSmallScreenState } from '../../state/UIState';

const BreadcrumbWrapper = styled('div')<{ isSmallScreen: boolean; $noBottomMargin?: boolean }>`
  display: flex;
  gap: 4px;
  align-items: center;
  margin-bottom: ${({ isSmallScreen, $noBottomMargin }) =>
    $noBottomMargin ? '0px' : isSmallScreen ? '0px' : '24px'};
`;

interface BreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
  /** When the parent row supplies spacing (e.g. PageHeader + actions). */
  disableBottomMargin?: boolean;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ breadcrumbs, disableBottomMargin }) => {
  const navigate = useNavigate();
  const { colors } = useTheme();
  const isSmallScreen = useAtomValue(isSmallScreenState);

  return (
    <BreadcrumbWrapper isSmallScreen={isSmallScreen} $noBottomMargin={disableBottomMargin}>
      {breadcrumbs.map((breadcrumb, index) => {
        const url = breadcrumb?.url;
        const textColor = breadcrumb?.color;
        return (
          <Typography
            key={index}
            variant='body'
            style={{
              cursor: url ? 'pointer' : undefined,
            }}
            color={textColor || colors.text.caption}
            onClick={() => {
              if (!url) return;
              navigate(url);
            }}
          >
            {index > 0 && ' / '}
            {breadcrumb.title}
          </Typography>
        );
      })}
    </BreadcrumbWrapper>
  );
};

export default Breadcrumbs;
